<template>
  <PlanList></PlanList>
</template>

<script>
  import PlanList from '@/page/modules/plan/list'
  export default {
    components: { PlanList },
    data () {
      return {
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/page/entrain/plan/list.vue